import { fromJS, Map } from 'immutable';

import { fetchNotifications, fetchCustomNotifications } from './actions';

export const defaultState = Map({
  notifications: [],
  manageNotification: {},
  customNotifications: []
});

export default function notificationsReducer(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration

  switch (action.type) {
    case fetchNotifications.event.success:
      return newState.set('notifications', action.payload);
    case fetchCustomNotifications.event.success:
      return newState.set('customNotifications', action.payload);
    default:
      return newState;
  }
}

export const notifications = state => state.notifications?.get('notifications');
export const customNotification = state => {
  const customNotifications = state.notifications.get('customNotifications');
  return customNotifications
    .filter(({ notificationType }) => notificationType === 'CUSTOM_CURRENT')
    .sort((a, b) => a.displayStart - b.displayStart)[0];
};

const getSortedNotificationDates = notifications =>
  notifications
    .map(not => ({
      displayStart: new Date(not.displayStart),
      displayEnd: new Date(not.displayEnd),
      outageStart: new Date(not.outageStart),
      outageEnd: new Date(not.outageEnd)
    }))
    .sort((a, b) => a.outageStart - b.outageStart);

export const currentOutage = state => {
  const today = new Date();
  const currNotifications = notifications(state);
  const notificationDates = getSortedNotificationDates(currNotifications);

  return notificationDates.filter(not => today >= not.outageStart && today <= not.outageEnd)[0] || null;
};

export const currentOutageNotification = state => {
  const today = new Date();
  const currNotifications = notifications(state);
  const notificationDates = getSortedNotificationDates(currNotifications);

  return notificationDates.filter(not => today >= not.displayStart && today <= not.displayEnd)[0] || null;
};
